export type SystemMessagesTab = "liveScheduled" | "past" | "inactive";
interface SystemMessagesTabsProps {
  activeTab: SystemMessagesTab;
  onTabChange: (tab: SystemMessagesTab) => void;
  counts: {
    liveScheduled: number;
    past: number;
    inactive: number;
  };
}
const TABS: { key: SystemMessagesTab; label: string }[] = [
  { key: "liveScheduled", label: "Live & Scheduled" },
  { key: "past", label: "Past" },
  { key: "inactive", label: "Deleted" },
];
export default function SystemMessagesTabs({
  activeTab,
  onTabChange,
  counts,
}: SystemMessagesTabsProps) {
  return (
    <>
      <style>{`
        .system-messages-tab:focus {
          outline: none;
        }
        .system-messages-tab:focus-visible {
          outline: 2px solid #003a5d;
          outline-offset: 2px;
        }
      `}</style>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          flexWrap: "wrap",
        }}
      >
        {TABS.map(({ key, label }) => {
          const isActive = activeTab === key;
          const count = counts[key];
          return (
            <button
              key={key}
              type="button"
              className="system-messages-tab"
              onClick={() => onTabChange(key)}
              aria-pressed={isActive}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor =
                    "rgba(241,245,249,0.6)";
                  e.currentTarget.style.color = "#0f172a";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#1e293b";
                }
              }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.5rem 1rem",
                borderRadius: "0.375rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                border: `1px solid ${isActive ? "#e2e8f0" : "transparent"}`,
                backgroundColor: isActive ? "#f1f5f9" : "transparent",
                color: isActive ? "#0f172a" : "#1e293b",
                boxShadow: isActive ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
                cursor: "pointer",
                transition: "all 150ms",
                whiteSpace: "nowrap",
              }}
            >
              {label}
              <span
                aria-label={`${count} items`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "22px",
                  height: "20px",
                  padding: "0 0.375rem",
                  borderRadius: "0.375rem",
                  backgroundColor: isActive ? "#475569" : "#cbd5e1",
                  color: isActive ? "#fff" : "#334155",
                  fontSize: "11px",
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
}
